import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { BreakdownModel } from 'src/app/models/preliminaries/breakdown-model';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { QuotationVersionModel } from 'src/app/models/preliminaries/quotation-version.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { QuotationBreakdownCaptureTableModel } from 'src/app/models/tables/preliminaries/quotation-breakdown-capture-table.model';
import { QuotationDetailCaptureTableModel } from 'src/app/models/tables/preliminaries/quotation-detail-capture-table.model';
import { BreakdownService } from 'src/app/services/preliminaries/breakdown.service';
import { QuotationDetailService } from 'src/app/services/preliminaries/quotation-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CopyQuotationComponent } from '../copy-quotation/copy-quotation.component';
import { QuotationModel } from 'src/app/models/preliminaries/quotation.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-quotation-detail',
  templateUrl: './quotation-detail.component.html',
  styleUrls: ['./quotation-detail.component.scss'],
  standalone: false
})
export class QuotationDetailComponent implements OnInit {
  @ViewChild('copyQuotation') copyQuotationModalComponent?: CustomModalComponent | null = null;
  @Input('quotationVersion')
  set changeQuotationVersion(changeVersion: QuotationVersionModel) {
    this.changeVersion(changeVersion);
  }
  @Input('quotationContract') set quotation(change: QuotationModel) {
    this.changeQuotation(change);
  }

  quotationContract: QuotationModel = new QuotationModel();
  @Input() permissionUpdatable: boolean = false;
  @Output() emitQuantityDetails = new EventEmitter<number>();
  @Output() costCenterDetailsCount = new EventEmitter<number>();

  activeTabIndex = 0;
  ascendant: boolean = true;
  columnSort: string | null = null;
  breakdownData: PagedResponseModel<QuotationBreakdownCaptureTableModel> = new PagedResponseModel<QuotationBreakdownCaptureTableModel>();
  breakdownHeader: ColumnResponseModel[] = [];
  breakdownModel: BreakdownModel = new BreakdownModel();
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  componentCopyQuotation = CopyQuotationComponent;
  detailData: PagedResponseModel<QuotationDetailCaptureTableModel> = new PagedResponseModel<QuotationDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledDetail: boolean = false;
  disabledActions: boolean = false;
  enableTabBrakedown: boolean = false;
  isFormView: boolean = false;
  inputsForCopy$ = new BehaviorSubject<any>({
    quotationVersion: QuotationVersionModel,
    quotationType: 0
  });
  labelBreakdown: string = 'Despiece';
  limit: number = 10;
  page: number = 1;
  quotationVersion: QuotationVersionModel = new QuotationVersionModel();
  quotationVersionId: number = 0;
  outputCopy$ = new Subject<any>();
  previousSort: { field: string; isAscsendant: number };
  quotationDetailModel: QuotationDetailModel = new QuotationDetailModel();
  updateFormDetail: boolean = false;
  tableActions: TableAction[] = [];
  tableActionsBreakdown: TableAction[] = [];
  subscription: Subscription;

  constructor(
    private breakdownService: BreakdownService,
    private confirmDialogService: ConfirmDialogService,
    private quotationDetailService: QuotationDetailService,
    private router: Router,
    private toastHandlerService: ToastHandlerService,
  ) { }

  ngOnInit() {
    this.subscription = this.outputCopy$.subscribe(({ type }) => {
      switch (type) {
        case 'updateList':
          this.getQuotationDetailsByVersion();
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  changeQuotation(changeQuotation: QuotationModel) {
    this.quotationContract = changeQuotation;
    this.handleTabChange(0);
  }

  changeVersion(changeVersion: QuotationVersionModel) {
    this.quotationVersion = changeVersion;
    this.getColumnsForDetail();
    this.quotationDetailModel = new QuotationDetailModel;
    this.labelBreakdown = 'Despiece'
    // this.activeTabIndex = 0;
    this.quotationVersionId = this.quotationVersion.quotationVersionId;
    this.disabledActions, this.disabledDetail = !this.quotationVersion.active || this.quotationVersion.quotationVersionId == 0;
    this.tableActions = this.getDefaultActions();
    this.tableActionsBreakdown = this.quotationVersion.active ? this.getDefaultActionsBreakdown() : [];

    // Aqui falta quitar columna de acciones
    if (this.quotationVersionId != 0) {
      this.getQuotationDetailsByVersion();
    } else {
      this.breakdownData = new PagedResponseModel<QuotationBreakdownCaptureTableModel>();
      this.detailData = new PagedResponseModel<QuotationDetailCaptureTableModel>();
    }
  }

  async createNewSolution() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        'El usuario no tiene permisos para crear cotizaciones. Comuníquese con el administrador del sistema.'
      );
      return;
    }

    this.quotationDetailModel = new QuotationDetailModel();
    this.quotationDetailModel.quotationVersionId = this.quotationVersionId;
    this.handleTabChange(1);
  }



  async deleteQuotationDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;
    const accepted = await this.confirmDialogService.confirm("¿Desea eliminar la solución?");
    if (accepted) {
      try {
        await firstValueFrom(this.quotationDetailService.deleteSomeDetails(selectedIds));
        this.toastHandlerService.showToast('success', 'La solución fue eliminada exitosamente de la cotización.', 'Atención');
        this.breakdownModel = new BreakdownModel();
        this.clearSelectionTrigger++;
        await this.getQuotationDetailsByVersion();
        this.updateFormDetail = !this.updateFormDetail;
      } catch (error) {
        console.error('Error al eliminar la solución de la cotización.', error);
      }
    }

  }

  async exportSolution(quotationSolutionId: number) {
    try {
      const blob = await firstValueFrom(this.breakdownService.exportSolution(quotationSolutionId));
      if (blob) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Solucion con despiece.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error al exportar la solución con despiece.', error);
    }
  }

  async getBreakdownById(breakdownId: number) {
    this.breakdownModel = await firstValueFrom(this.breakdownService.getBreakdownById(breakdownId));
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      },
      {
        label: 'Exportar Despice',
        icon: 'pi pi-file-excel',
        action: 'exportExcel'
      }
    ];
  }

  getDefaultActionsBreakdown(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getQuotationDetailsByVersion() {
    try {
      this.detailData = await firstValueFrom(this.quotationDetailService.getQuotationDetailsByVersion(this.quotationVersionId, this.page, this.limit, this.columnSort, this.ascendant));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
      //Obtener soluciones con cco.
      const count = this.detailData.items.filter(d => d.costCenterCode?.trim()).length;
      this.costCenterDetailsCount.emit(count);
    } catch (error) {
      console.error('Error al buscar las cotizaciones solución.', error);
    }
  }

  async getQuotationDetailById(quotationDetailId: number) {
    this.quotationDetailModel = await firstValueFrom(this.quotationDetailService.getQuotationDetailById(quotationDetailId));
  }

  async getColumnsForDetail() {
    try {
      if (this.detailHeader.length === 0) {
        this.detailHeader = await firstValueFrom(this.quotationDetailService.getColumnsForQuotationDetailsByVersion());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta solución.', error);
    }
  }

  newSolution() {
    this.router.navigate([`/quotation/register/${this.quotationVersion.quotationId}/solution`], { queryParams: { version: this.quotationVersionId } }
    );
  }

  public async handleTabChange(tabIndex: number) {
    if (this.activeTabIndex === tabIndex) return;
    this.activeTabIndex = tabIndex;
    switch (this.activeTabIndex) {
      case 0:
        await Promise.all([
          this.getColumnsForDetail(),
          this.getQuotationDetailsByVersion()
        ]);
        this.detailData = {
          ...this.detailData,
          currentPage: 1,
          pageSize: 10
        };
        break;
    }
  }

  async onAction(event: { action: string, item?: QuotationDetailCaptureTableModel | QuotationBreakdownCaptureTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      switch (this.activeTabIndex) {
        case 0:
          this.quotationDetailModel = await firstValueFrom(this.quotationDetailService.getQuotationDetailById(event.item!.id));
          await this.handleTabChange(1);
          break;
      }
    }

    if (event.action === 'bulk-delete' && event.selectedItems) {
      switch (this.activeTabIndex) {
        case 0:
          this.deleteQuotationDetail(event.selectedItems);
          break;
      }
    }
    if (event.action === 'exportExcel') {
      this.exportSolution(event.item!.id);
    }
  }

  getLabelBreakdown(label: string): string {
    if (label.length > 75) {
      return `${label.slice(0, 75 - 3)}...`;
    }
    return label;
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    switch (this.activeTabIndex) {
      case 0:
        await this.getQuotationDetailsByVersion();
        break;
    }
  }

  openCopyQuotation() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para copiar cotizaciones, comuniquese con el administrador del sistema.', 'Atención');
      return;
    }
    this.updateInputs();
    this.copyQuotationModalComponent && this.copyQuotationModalComponent.show();
  }

  updateInputs() {
    this.inputsForCopy$.next({
      quotationVersion: this.quotationVersion,
      quotationType: this.quotationContract.quotationTypeId
    });
  }
}

